import { IonButton, IonRow } from '@ionic/react';
import { Paper, TableContainer } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import API from '../../../../../api';
import { INDIAN_CASINO_GAMES_MAP } from '../../../../../constants/IndianCasinoGames';
import Lucky7ResultsTable from '../Lucky7/Lucky7ResultsTable';

type RouteParams = {
  gameCode: string;
};

type ResultDTO = {
  result: string;
  mid: string;
};

const ResultsListView: React.FC = () => {
  const [resultsList, setResultsList] = useState<ResultDTO[]>([]);
  const [pageNum, setPageNumber] = useState<number>(1);
  const pageSize = 25;
  const { gameCode } = useParams<RouteParams>();

  const fetchResultsList = async (pageNo: number) => {
    try {
      let response;
      if (sessionStorage.getItem('jwt_token')) {
        response = await API.post(
          '/indian-casino/mids-by-sport',
          {},
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
            params: {
              gameType: INDIAN_CASINO_GAMES_MAP[gameCode],
              pageNum: pageNo,
              nRec: pageSize,
            },
          }
        );
      }

      if (response.status === 200) {
        setResultsList(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchResultsList(pageNum);
  }, [gameCode, pageNum]);

  return (
    <div className="reports-ctn results-list-ctn">
      <div className="header-ctn">
        <IonRow>
          <div className="page-title">
            {gameCode === 'lucky7' ? 'Lucky 7A' : 'Lucky 7B'} Results
          </div>
        </IonRow>
      </div>
      <div className="content-ctn">
        <div className="tbl-ctn">
          <TableContainer className="results-table-container" component={Paper}>
            {gameCode === 'lucky7' || gameCode === 'lucky7b' ? (
              <Lucky7ResultsTable resultsList={resultsList} />
            ) : null}
          </TableContainer>
        </div>
        <IonRow className="footer-row">
          {pageNum === 1 ? null : (
            <IonButton
              className="btn-prev pagination-btn"
              onClick={() => setPageNumber(pageNum - 1)}
            >
              Prev({pageNum - 1})
            </IonButton>
          )}
          {resultsList && resultsList.length === pageSize ? (
            <IonButton
              className="btn-next pagination-btn"
              onClick={() => setPageNumber(pageNum + 1)}
            >
              Next({pageNum + 1})
            </IonButton>
          ) : null}
        </IonRow>
      </div>
    </div>
  );
};

export default ResultsListView;
